import React, { useEffect, useState } from "react";
import channels from "../channels";
import { Container } from "./styles.js";
import { Link } from "react-router-dom";
import { FaXmark } from "react-icons/fa6";

export default function WatchChannel({ category, channel }) {

    const [selectedChannel, setSelectedChannel] = useState(null);
    const [selectedSubChannel, setSelectedSubChannel] = useState(null);

    useEffect(() => {
        if (category && channel) {
            // Encontra a categoria
            const categoryData = channels.find(
                (categoria) => categoria.category.toLowerCase() === category.toLowerCase()
            );

            if (categoryData) {
                // Encontra o canal principal
                const channelData = categoryData.channels.find(
                    (ch) => ch.name.toLowerCase() === channel.toLowerCase()
                );

                setSelectedChannel(channelData || null);
                setSelectedSubChannel(channelData?.channels?.[0] || null); // Define o primeiro subcanal como padrão
            } else {
                setSelectedChannel(null);
                setSelectedSubChannel(null);
            }
        }
    }, [category, channel]);

    // Função para lidar com a mudança de canal secundário
    const handleSubChannelChange = (event) => {
        const subChannelName = event.target.value;
        const subChannel = selectedChannel.channels.find(
            (subCh) => subCh.name === subChannelName
        );
        setSelectedSubChannel(subChannel);
    };

    return (
        <Container>
            <header className="header-watch-channel">
                <Link to="/canais">
                    <FaXmark size={20} color="#fff" />
                </Link>
            </header>

            {selectedChannel ? (
                <div className="content">
                    <h1>{selectedChannel.name}</h1>

                    {/* Exibe o canal principal ou o canal secundário selecionado */}
                    <iframe
                        src={selectedSubChannel ? selectedSubChannel.url : selectedChannel.url}
                        title={selectedSubChannel ? selectedSubChannel.name : selectedChannel.name}
                        allowFullScreen
                    ></iframe>
                    {selectedChannel.channels && selectedChannel.channels.length > 0 && (
                        <div>
                            <select
                                id="subChannelSelect"
                                onChange={handleSubChannelChange}
                                value={selectedSubChannel ? selectedSubChannel.name : ""}
                            >
                                {selectedChannel.channels.map((subChannel) => (
                                    <option key={subChannel.name} value={subChannel.name}>
                                        {subChannel.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                    )}
                </div>
            ) : (
                <h2>Canal não encontrado</h2>
            )}
        </Container>
    );
}
